"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.bonusesandsponsorship-dashboard", {
      url: "bonusesandsponsorship-dashboard",
      resolve: {
        model: [
          "BonusRequest",
          function (BonusRequest) {
            return BonusRequest.dashboard().$promise;
          },
        ],
        list: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.dashboardPage().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/BonusesAndSponsorships/views/dashboard.html",
          controller: "bonusDashboardCtrl",
          controllerAs: "vm",
        },
      },
    });

    // Bonuses and Sponsorship
    $stateProvider.state("main.bonusesandsponsorship", {
      url: "bonusesandsponsorship",
      resolve: {
        list: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.list().$promise;
          },
        ],
        subAreas: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.subAreas().$promise;
          },
        ],
        status: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.status().$promise;
          },
        ],
        solicitants: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.solicitants().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/BonusesAndSponsorships/views/bonus.list.html",
          controller: "bonusListCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.bonuses", {
      url: "bonusesandsponsorship/:id",
      resolve: {
        model: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            if ($stateParams.id != 0) {
              return BonusRequest.get({ id: $stateParams.id }).$promise;
            }

            return {};
          },
        ],
        types: [
          "BonusRequest",
          function (BonusRequest) {
            return BonusRequest.types().$promise;
          },
        ],
        deposits: [
          "BonusRequest",
          function (BonusRequest) {
            return BonusRequest.deposits().$promise;
          },
        ],
        subAreas: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.subAreas({ all: false }).$promise;
          },
        ],
        productLines: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.productLines().$promise;
          },
        ],
        attachment: [
          "$stateParams",
          "Attachment",
          function ($stateParams, Attachment) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return Attachment.list({
              promotionRequestId: id,
              moduleId: 3,
            }).$promise;
          },
        ],
        workflowApprovals: [
          "$stateParams",
          "WorkflowApproval",
          function ($stateParams, WorkflowApproval) {
            var id = $stateParams.id ? $stateParams.id : 0;

            return WorkflowApproval.list({
              page: 1,
              pageSize: 1000,
              promotionRequestId: id,
            }).$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/BonusesAndSponsorships/views/bonus.edit.html",
          controller: "bonusEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
